<template>
  <div class="right-menu-item hover-effect">
    <el-dropdown trigger="click" @command="handleCommand">
      <template #default>
        <el-icon style="color: aliceblue; font-size: 25px; cursor: pointer; position: relative; top: 7px">
          <QuestionFilled />
        </el-icon>
      </template>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item command="manual">{{ $t('contact.menu.manual') }}</el-dropdown-item>
          <el-dropdown-item command="form">{{ $t('contact.menu.form') }}</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script>
import { QuestionFilled } from '@element-plus/icons-vue';
import { getDownloadUrl } from '@/api/s3';
import { MANUAL_BUCKET } from '@/aws-exports';
import { errorNotify } from '@/utils/errorNotification';
import { mapGetters } from 'vuex';

export default {
  name: 'Contact',
  components: {
    QuestionFilled,
  },
  // props: { tenantID, userID } を削除
  computed: {
    ...mapGetters(['user_name', 'tenantId']),
  },
  methods: {
    async handleCommand(command) {
      if (command === 'manual') {
        const bucketName = MANUAL_BUCKET[import.meta.env.MODE];
        const objKey = 'sensor-manager.pdf';
        try {
          const url = await getDownloadUrl(bucketName, objKey);
          if (url) {
            window.open(url, '_blank');
          } else {
            errorNotify({ status: -4, data: [{ cause: this.$t('contact.error.manualFetch') }] });
          }
        } catch {
          errorNotify({ status: -4, data: [{ cause: this.$t('contact.error.manualFetch') }] });
        }
      } else if (command === 'form') {
        const baseUrl =
          'https://forms.office.com/Pages/ResponsePage.aspx?id=lhD_r9h_3UyHmn21Ckcoeqi33nKle6BLpn2dWE9_9JBUOERRT0hQSk81Q09INlpYVks1VThSWU05SC4u';
        const url = `${baseUrl}&r60be833b51a44bbdad2d0e96846b6796=${encodeURIComponent(this.tenantId)}&r2f05b3871dcd49c0a7b2237e94ec1763=${encodeURIComponent(this.user_name)}`;
        window.open(url, '_blank');
      }
    },
  },
};
</script>

<style scoped>
/* navbarのflex・line-heightに依存し、アラインメントを揃える */
.right-menu-item {
  height: 100%;
  display: inline-flex;
  align-items: center;
  vertical-align: 10px;
  padding: 0 8px;
}
</style>
